"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dialogHeaderTokens = void 0;
const Global_1 = require("../../DesignSystem/tokens/Global");
const DesignToken_1 = __importDefault(require("../../DesignSystem/types/DesignToken"));
const GlobalDesignToken_1 = require("../../DesignSystem/types/GlobalDesignToken");
const dialogHeaderBackgroundColor = new DesignToken_1.default({
    name: 'dialog-header-backgroundColor',
    parent: [
        Global_1.globalTokens.colorBackgroundDefaultPrimary,
        Global_1.globalTokens.oldTokens.colorBackgroundHeader
    ]
});
const dialogHeaderColor = new DesignToken_1.default({
    name: 'dialog-header-color',
    parent: [Global_1.globalTokens.colorForegroundDefaultPrimary, Global_1.globalTokens.oldTokens.colorTextHeader]
});
const dialogHeaderHeight = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'dialog-header-height',
    fallback: '32px'
});
const dialogHeaderTitleFontWeight = new DesignToken_1.default({
    name: 'dialog-header-title-fontWeight',
    parent: [Global_1.globalTokens.fontWeightMedium, Global_1.globalTokens.oldTokens.fontWeightNormal]
});
const dialogHeaderTitleLineHeight = new DesignToken_1.default({
    name: 'dialog-header-title-lineHeight',
    parent: [Global_1.globalTokens.lineHeightL, Global_1.globalTokens.oldTokens.lineHeightXL]
});
const dialogHeaderTitleFontSize = new DesignToken_1.default({
    name: 'dialog-header-title-fontSize',
    parent: [Global_1.globalTokens.fontSizeL, Global_1.globalTokens.oldTokens.fontSizeL]
});
exports.dialogHeaderTokens = {
    dialogHeaderTitleFontWeight,
    dialogHeaderTitleLineHeight,
    dialogHeaderTitleFontSize,
    dialogHeaderBackgroundColor,
    dialogHeaderColor,
    dialogHeaderHeight
};
//# sourceMappingURL=DialogHeader.js.map